import React, { useState } from 'react';
import { StaticImageData } from 'next/image';

import Link, { LinkProps } from 'Elements/Link';

import {
    Figure,
    HeadingWrapper,
    Heading,
    Border,
    ImageWrapperDefault,
    StyledImage,
    PlayButton,
    PlayIcon
} from './ImageAnimated.styled';

export interface Props {
    heading: string;
    image: {
        src: StaticImageData | string;
        alt?: string;
    };
    link: LinkProps;
}

const ImageAnimated: React.FC<Props> = props => {
    const { heading, image, link } = props;

    const [isHovering, setIsHovering] = useState(false);

    return (
        <Figure>
            <HeadingWrapper>
                <Heading>{heading}</Heading>
            </HeadingWrapper>
            <Link
                {...link}
                data-hover={isHovering}
                onMouseOver={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                <ImageWrapperDefault>
                    <StyledImage
                        src={image.src}
                        alt={image.alt || ''}
                        fill
                        $isHovering={isHovering}
                    />
                    <PlayButton $isHovering={isHovering}>
                        <PlayIcon />
                    </PlayButton>
                    <Border $isHovering={isHovering} />
                </ImageWrapperDefault>
            </Link>
        </Figure>
    );
};

export default ImageAnimated;
